import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReturnObject } from '../../models/returnObject';
import { Task } from '../../models/task';
import { APIService } from '../api.service';

@Injectable()
export class TaskService {

    constructor(private api: APIService) {}

    getTasks(projNo: string, weekNo: string): Observable<ReturnObject<Array<Task>>> {
        return this.api.getAPI(`task/${projNo}/${weekNo}`);
    }
}
